export enum CartFulfillEventType {
  OPEN_PASSENGER_PICKER = "OPEN_PASSENGER_PICKER",
  CLEAR_CART_FULFILL_ERROR = "CLEAR_CART_FULFILL_ERROR",
  // User Action Events
  USER_ACTION_SUCCESS = "USER_ACTION_SUCCESS",
  USER_ACTION_ERROR = "USER_ACTION_ERROR",
}

export interface OpenPassengerPicker {
  type: CartFulfillEventType.OPEN_PASSENGER_PICKER;
}

export interface ClearCartFulfillError {
  type: CartFulfillEventType.CLEAR_CART_FULFILL_ERROR;
}
export interface CartFulfillUserActionSuccess {
  type: CartFulfillEventType.USER_ACTION_SUCCESS;
}

export interface CartFulfillUserActionError {
  type: CartFulfillEventType.USER_ACTION_ERROR;
}

export type CartFulfillEvents =
  | OpenPassengerPicker
  | ClearCartFulfillError
  | CartFulfillUserActionSuccess
  | CartFulfillUserActionError;
